import React from "react";
import { Typography } from "@mui/material";

const DefaultCell = ({ value, fontSize = "0.8125rem" }) => {
  return (
    <Typography 
      variant="body2" 
      sx={{ 
        fontWeight: 500, 
        fontSize: fontSize,
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
    >
      {value || "-"}
    </Typography>
  );
};

export default DefaultCell;

